module.exports = __webpack_public_path__ + "static/media/Minion3-Semibold.05485324.svg";